import { Component, OnInit } from '@angular/core';
import {StoreService} from '../../store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import {UtilitiesService} from 'src/app/core/utilities.service';
import { StoreInfoService } from 'src/app/store-info.service';

@Component({
  selector: 'app-emailTemplate',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.scss']
})
export class EmailTemplateComponent implements OnInit {

    imagePath: any;
    imgURL: any;
    message: string;
    bearer;
    templates: any = [];
    customerTemplates: any = [];
    dealerTemplates: any = [];
    closeResult = '';
    status;
    errorMsg;

    store_id;
    template_id;

    template_image;
    template_display_name: string = '';
    template_description: string = '';
    curr_template_id;
    template_type;
    button_name;
    selected_template;
    email_template_id;

    loading = true;
    storeInfo$ = this.storeInfoService.getStoreInfos();

    searchQuery: string = '';
    activeTab: string = 'all';

    setTab(tab: string) {
      this.activeTab = tab;
    }

    get filteredCustomerTemplates(): any[] {
      if (!this.customerTemplates) return [];
      const query = (this.searchQuery || '').toLowerCase().trim();
      if (!query) return this.customerTemplates;
      return this.customerTemplates.filter((item: any) =>
        (item.display_name && item.display_name.toLowerCase().includes(query)) ||
        (item.description && item.description.toLowerCase().includes(query))
      );
    }

    get filteredDealerTemplates(): any[] {
      if (!this.dealerTemplates) return [];
      const query = (this.searchQuery || '').toLowerCase().trim();
      if (!query) return this.dealerTemplates;
      return this.dealerTemplates.filter((item: any) =>
        (item.display_name && item.display_name.toLowerCase().includes(query)) ||
        (item.description && item.description.toLowerCase().includes(query))
      );
    }

    get filteredAdminTemplates(): any[] {
      return this.filteredDealerTemplates;
    }

    get totalFilteredCount(): number {
      let count = 0;
      if (this.activeTab === 'all' || this.activeTab === 'customer') {
        count += this.filteredCustomerTemplates.length;
      }
      if (this.activeTab === 'all' || this.activeTab === 'dealer' || this.activeTab === 'admin') {
        count += this.filteredDealerTemplates.length;
      }
      return count;
    }

    constructor(
      private svc: StoreService,
      private modalService: NgbModal,
      private router: Router,
      private utils: UtilitiesService,
      private storeInfoService: StoreInfoService
      ) { }

    ngOnInit(): void {

      this.bearer = localStorage.getItem('bearer');
      this.store_id = localStorage.getItem('store_id');

      this.getStoreList();
      this.filterSelection('all');

    }


    getTemplate(id_template) {

      // this.svc.getEmailTemplates(this.bearer, this.store_id).subscribe(res => {
      this.svc.getEmailTemplates(this.bearer).subscribe(res => {

        this.templates = res['data'];

        // if (id_template != 1) {
        //   var arr = [];
        //   var current_template = this.templates.find(x => x.template_id === id_template);
        //   if (current_template) arr.push(current_template);
        //   this.templates = arr;
        // }

        this.customerTemplates = this.templates.filter((t: any) => t.recipient === 'customer');
        this.dealerTemplates = this.templates.filter((t: any) => t.recipient === 'dealer');
        this.loading = false;

      })
    }

    getStoreList() {
      this.storeInfo$.subscribe(
        (res) => {
          this.email_template_id = res.email_template_id;
          this.getTemplate(this.email_template_id)
        });
    }

    preview(data){
        this.template_image = data.image
        this.template_display_name = data.display_name
        this.template_description = data.description
        this.curr_template_id = data.id
        this.template_type = data.type
        this.selected_template = data
        console.log('data',data);

        if (this.template_type == 2) {
          this.button_name = "Edit"
        } else{
          this.button_name = "Custom"
        }
    }

    templateEditor(){

      if (this.template_type != 2) {

        this.duplicateTemplate()

      } else{
        this.router.navigate(['/dashboard/edit-template',this.curr_template_id])
          // .then(() => {
          //   window.location.reload();
          // });
      }

    }

    duplicateTemplate(){

      const params = {
        store_id:this.store_id,
        template:this.selected_template.template,
        parent_id:this.selected_template.template_id,
        template_json: this.selected_template.template_json == undefined?'':this.selected_template.template_json,
        image:this.selected_template.image
      };

      console.log('params',params);


      this.svc.duplicateEmailTemplate(params, this.bearer).subscribe(res=>{

        console.log('duplicateEmailTemplate',res);
        var latest_id = res['data']['custom_email_id']

        this.router.navigate(['/dashboard/edit-template',latest_id])
        // .then(() => {
        //   window.location.reload();
        // });

      },(err)=>{

        console.log('err',err);
        this.utils.notify.showError(this.utils.translate("Error"));
      })

    }

    openModal(content) {
          this.modalService.open(
              content, {
                  ariaLabelledBy: 'modal-basic-title',
                  size: 'md',
                  windowClass: 'modal-customer',
                  centered: true,
                  backdrop: 'static'
              }).result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });
      }

    private getDismissReason(reason: any): string {
          if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
          } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
          } else {
            return `with: ${reason}`;
          }
      }

    open() {
      const modalRef = this.modalService.open(UploadImageComponent,{ size: 'lg', backdrop: 'static' });
      modalRef.componentInstance.id = 10;
      modalRef.result.then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      });
    }

    successModal(success) {
      this.modalService.open(
          success, {
              ariaLabelledBy: 'modal-basic-title',
              size: 'md',
              windowClass: 'modal-success',
              centered: true,
              backdrop: 'static'
          }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          // location.reload();
          window.location.reload();
          this.modalService.dismissAll();

      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          //location.reload();
          this.modalService.dismissAll();
      });
      //location.reload();
  }


  filterSelection(c) {
    var x, i;
    x = document.getElementsByClassName("column");

    if (c == "all") c = "";
    for (i = 0; i < x.length; i++) {
      this.removeClass(x[i], "show");
      if (x[i].className.indexOf(c) > -1) this.addClass(x[i], "show");
    }
  }
   addClass(element, name) {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
      if (arr1.indexOf(arr2[i]) == -1) {element.className += " " + arr2[i];}
    }
  }
   removeClass(element, name) {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
      while (arr1.indexOf(arr2[i]) > -1) {
        arr1.splice(arr1.indexOf(arr2[i]), 1);
      }
    }
    element.className = arr1.join(" ");
  }

}
